declare namespace $ {

	export class $mol_icon_arrow_up extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=up.view.tree.d.ts.map